import { getOaInfo } from "@/utils/auth";

export function navigateToJoinMember({ role, nextRole, router, toast }) {
  const data = getOaInfo();

  if (data && data.maritalStatus === "已婚") {
    toast("系统显示状态为已婚,不允许注册会员");
    return;
  }
  if (role === "Matchmaker") {
    toast("您已加入红娘，为了保证身份唯一性，不可再加入会员");
    return;
  }
  if (role === "Member") {
    toast("您已加入会员");
    return;
  }
  if (nextRole === "Matchmaker") {
    toast("您已申请加入红娘,目前正在审核中。");
    return;
  }
  if (nextRole === "Member") {
    toast("您已申请加入会员,目前正在审核中。");
    return;
  }

  router.push({ path: "/joinMatchmakerTeam" });
}



// WEBPACK FOOTER //
// ./src/utils/memberEntry.js